import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  settingRow: {
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.new.spacing.medium,
    padding: `${theme.new.spacing.medium} 0`,
    borderBottom: `1px solid ${theme.new.color.line.hairline}`,
  },
  learnMore: {
    paddingTop: theme.new.spacing.xsmall,
  },
}));

export default useStyles;
